
  
<p class="big">Break</p>
<p class="small" *ngIf="breakMessage">{{breakMessage}}</p>